// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e7753672","455":"0f795f3c","977":"26a29b33"}[chunkId] + ".chunk.js";
};